const validateBannerImage = (file) => {
    const MIN_WIDTH = 940;
    const MAX_WIDTH = 982;
    const MIN_HEIGHT = 280;
    const MAX_HEIGHT = 283;

    return new Promise((resolve) => {
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = function () {
            const width = img.width;
            const height = img.height;

            URL.revokeObjectURL(objectUrl);

            const validWidth = width >= MIN_WIDTH && width <= MAX_WIDTH;
            const validHeight = height >= MIN_HEIGHT && height <= MAX_HEIGHT;
            console.log("validWidth:", validWidth);
            console.log("validHeight:", validHeight);
            resolve(validWidth && validHeight);
        };

        img.onerror = () => resolve(false);

        img.src = objectUrl;
    });
};

export default validateBannerImage;